import axiosIS from "@/api/net/axios.js"
import ApiConfig, { baseUrl } from "@/config/apiConfig.js"
export default {
  userLogin(data = {}) {
    return axiosIS(`${baseUrl}${ApiConfig.loginIn}`, data, { method: "post" })
  },
  // SVC-登出
  //   https://rg975ojk5z.feishu.cn/docx/DhN9d9zl1ojeryx2B6rcTay3ncd
  userLoginOut(data = {}, user_id) {
    return axiosIS(`${baseUrl}${ApiConfig.loginOut}/${user_id}`, data, { method: "post" })
  },
  // SVC-个人用户基本信息
  // https://rg975ojk5z.feishu.cn/docx/CZ9Wd29fRoxCVHxf6d9cbkrGnhc
  userGetInfo() {
    return axiosIS(`${baseUrl}${ApiConfig.getUserInfo}`, {}, { method: "get" })
  },
  getBanerConfig(){
    return axiosIS(`${baseUrl}${ApiConfig.getBanerConfig}`, {}, { method: "post" })
  },
  // 埋点上报
  userPoint() {
    return axiosIS(`${baseUrl}${ApiConfig.sendPoint}`, {}, { method: "get" })
  },
  // SVC-个人用户基本信息更新
  // https://rg975ojk5z.feishu.cn/docx/A6RIdAv5HofbOXxV3pxcSxKNn5f
  updateUserInfo(data) {
    return axiosIS(`${baseUrl}/api/user/profile/update`, data, { method: "post" })
  },
  // SVC-个人用户基本信息更新
  // https://rg975ojk5z.feishu.cn/docx/A6RIdAv5HofbOXxV3pxcSxKNn5f
  sendEmail(email) {
    return axiosIS(`${baseUrl}${ApiConfig.sendEmail}?email=${email}`, {}, { method: "get" })
  },
  userConfig() {
    return axiosIS(`${baseUrl}${ApiConfig.getConfig}`, {}, { method: "get" })
  },
  switchLanguage(data = {}) {
    return axiosIS(`${baseUrl}${ApiConfig.language}`, data, { method: "post" })
  },
  // 用户注销
  deleteAccount(data = {}) {
    return axiosIS(`${baseUrl}/api/user/account/delete`, data, { method: "post" })
  },
  // 获取验证码
  getVerifyCode(data = {}) {
    return axiosIS(`${baseUrl}/api/user/login/otp/message`, data, { method: "post" })
  },
  userLoginCn(data = {}) {
    return axiosIS(`${baseUrl}/api/user/login`, data, { method: "post" })
  },
  userCodePeport(data = {}) {
    return axiosIS(`${baseUrl}/api/pgc/channel/code/check`, data, { method: "post" })
  },
  inviteCodePoint(data = {}){
    return axiosIS(`${baseUrl}/api/pgc/invite/register_report`, data, { method: "post" })
  },
  // 邮件召回
  giveMailRecallCredits(data = {}){
    return axiosIS(`${baseUrl}/api/pgc/mail-recall/give-credits`, data, { method: "post" })
  },
  userPaySuccess(data = {}){
    return axiosIS(`${baseUrl}/api/payment/issue_report`, data, { method: "post" })
  },
  giveCreditsExperiment(data = {}){
    return axiosIS(`${baseUrl}/api/pgc/give-credits/experiment`, data, { method: "get" })
  }
}